import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../../hoc/staticLayout'), { loading: () => <></>, ssr: true });
import LoginLayout from "../../hoc/appLayout";
const DegreeContent = dynamic(() => import('../../components/static/degreePage/degree/advanced'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';
import React, { useEffect, useState } from "react";
import Store from '../../store';
import { getIslamicTheologies } from "../../api/islamic_theologies";


function DegreeProgramAdvanced(props) {
	const [isMobile, setIsMobile] = useState(false);
	const { userAuth } = Store.getState();
	const [isLogin, setIsLogin] = useState(false);

	useEffect(() => {
		if (userAuth.authenticated && userAuth.token) {
			setIsLogin(true);
		}
		if (window.innerWidth < 767) {
			setIsMobile(true);
		}
	}, []);

	const meta = {
		title: "Choose a degree | Choose a concentration | Masters of Arts in Regligion | Masters of Divinity in Islamic Chaplaincy | Bayan",
		description: "Degree programs equip men and women with a firm grounding in Islamic thought and cultivates practical skills in a variety of religious contexts and professional settings.",
		route: "degree-programs",
	}

	return (
		<>
			{isLogin ?
				<LoginLayout theme={props.theme} meta={meta}>
					<DegreeContent router={props.router} islamicTheologiesData={props?.islamicTheologiesData} />
				</LoginLayout>
				:
				<Layout theme={props.theme} meta={meta}>
					<DegreeContent router={props.router} islamicTheologiesData={props?.islamicTheologiesData} />
				</Layout>}

		</>
	);
}

export async function getServerSideProps(ctx) {
	const islamicTheologiesData = await getIslamicTheologies();
	return { props: { islamicTheologiesData: islamicTheologiesData } }
}

export default withRouter(DegreeProgramAdvanced);
